// Imports
import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components/macro';
import { useAppDispatch } from '../../../../../../../shareables/foundation/front-end/redux/hooks';
import apiActions from '../../../../../../../shareables/integrations/api/redux/actions';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { GetRotatingPhotosResponse } from '../../../../../../../shareables/types/api/main/website/homepage/rotating-photos/get';
import Skeleton from 'react-loading-skeleton';


// Styled components
const Wrapper = styled.div<{ displayShadow: boolean }>`
	max-width: 100%;
	overflow: hidden;
	margin-top: 0.9375rem;
	border-radius: 0.1875rem;
	
	${({ displayShadow }) =>
		displayShadow &&
		css`
			box-shadow: 0 0 0.3125rem rgba(0, 0, 0, 0.2);
		`}
	
	.swiper-slide {
		width: 100% !important;
	}
`;

const SwiperImage = styled.img`
	width: 100%;
	aspect-ratio: 5 / 4;
	
	display: block;
`;


// Define the accepted props
interface Props {
	storybookRotatingPhotos?: GetRotatingPhotosResponse;
}


// Function component
const RotatingPhotos: React.FC<Props> = ({ storybookRotatingPhotos }) => {
	// Use state
	const [rotatingPhotos, setRotatingPhotos] = useState<GetRotatingPhotosResponse | null>(
		storybookRotatingPhotos ?? null
	);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Load rotating photos on mount
	useEffect(() => {
		void dispatch(
			apiActions.call<undefined, undefined, GetRotatingPhotosResponse>({
				action: 'GET',
				uri: `/website/${window.location.hostname}/homepage/rotating-photos`,
				completion: (json) => {
					setRotatingPhotos(json.response);
				},
			})
		);
	}, [dispatch]);
	
	
	// Return JSX
	return (
		<Wrapper displayShadow={Boolean(rotatingPhotos)}>
			<Swiper
				spaceBetween={100}
				modules={[Autoplay, EffectFade]}
				autoplay
				effect='fade'
				fadeEffect={{ crossFade: true }}
				slidesPerView='auto'
				centeredSlides
				speed={3000}
			>
				{!rotatingPhotos && (
					<SwiperSlide>
						<Skeleton width='100%' style={{ aspectRatio: '5 / 4' }} />
					</SwiperSlide>
				)}
				
				{rotatingPhotos?.photos?.map((photo, i) => (
					<SwiperSlide key={i}>
						<SwiperImage alt={`Rotating photo ${i + 1}`} src={photo} />
					</SwiperSlide>
				))}
			</Swiper>
		</Wrapper>
	);
};

export default RotatingPhotos;
